/* Myntic · cupón por seguirnos
 *
 * Cuenta qué redes abriste y, al llegar al mínimo, pide el correo y canjea
 * el cupón contra el Worker.
 *
 * LO QUE ESTE ARCHIVO NO HACE, Y CONVIENE QUE QUEDE ESCRITO: no comprueba
 * que de verdad siguieras a nadie. No se puede -- Instagram, TikTok y
 * Facebook no exponen «¿este usuario me sigue?» a nadie. Eso lo comprueba
 * el cajero mirando el teléfono. Lo que sí garantiza el sistema es que el
 * descuento se use una vez, por esa persona, en 24 horas y solo sobre
 * piezas que no estén ya rebajadas.
 *
 * El bloque nace con `hidden` en el marcado y lo enciende este script. Es
 * deliberado: si esto falla, la landing sigue siendo cinco enlaces que
 * funcionan. Lo que se pierde es el cupón, no la página.
 */
(function () {
  var caja = document.getElementById('cup');
  if (!caja) return;

  var API = caja.dataset.api;
  var MIN = parseInt(caja.dataset.min, 10) || 3;
  var LLAVE = 'myn-redes';

  var el = function (n) { return caja.querySelector('[data-cup="' + n + '"]'); };
  var invitacion = el('invitacion');
  var forma = el('forma');
  var listo = el('listo');
  var barra = caja.querySelector('.cup-bar i');

  /* El recuento vive en el navegador, así que se puede falsear -- y da
     igual: el servidor vuelve a exigir las tres y el cajero mira. Esto es
     comodidad, no control. */
  function leer() {
    try {
      var v = JSON.parse(localStorage.getItem(LLAVE) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (_) {
      return [];
    }
  }
  function guardar(v) {
    try { localStorage.setItem(LLAVE, JSON.stringify(v)); } catch (_) {}
  }

  function pintar() {
    var v = leer();
    var n = Math.min(v.length, MIN);
    var cuenta = el('cuenta');
    if (cuenta) cuenta.textContent = String(n);
    if (barra) barra.style.width = (n / MIN * 100) + '%';

    caja.querySelectorAll('.lx-r').forEach(function () {});
    document.querySelectorAll('.lx-r[data-red]').forEach(function (a) {
      a.classList.toggle('hecho', v.indexOf(a.dataset.red) !== -1);
    });

    var ya = v.length >= MIN;
    if (invitacion) invitacion.hidden = ya;
    if (forma) forma.hidden = !ya || !listo.hidden;
  }

  /* `pointerdown` y no `click`: en el móvil el enlace se lleva la pestaña al
     abrir la app de la red, y un `click` tardío puede no llegar a correr. */
  document.querySelectorAll('.lx-r[data-red]').forEach(function (a) {
    a.addEventListener('pointerdown', function () {
      var v = leer();
      if (v.indexOf(a.dataset.red) === -1) {
        v.push(a.dataset.red);
        guardar(v);
      }
      // El repintado se aplaza: si se hace ahora, la pantalla cambia bajo el
      // dedo justo cuando ya se está yendo a la otra app.
      setTimeout(pintar, 400);
    });
  });

  // Al volver de la app de la red, la pestaña se recupera de la caché y no
  // vuelve a ejecutar el script: `pageshow` es lo que sí se dispara.
  window.addEventListener('pageshow', pintar);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) pintar();
  });

  function fallo(msg) {
    var e = el('error');
    if (!e) return;
    e.textContent = msg;
    e.hidden = false;
  }

  function mostrarCupon(d) {
    el('codigo').textContent = d.codigo;

    /* El QR lo arma el servidor y nos da la URL hecha: asi la ruta puede
       cambiar sin tocar el tema. Se enseña solo cuando la imagen ha cargado
       de verdad -- si falla, queda el codigo escrito, que siempre se puede
       dictar. Un hueco roto al lado de un cupon se lee como que el cupon
       tampoco sirve. */
    var qr = el('qr');
    if (qr && d.qr) {
      qr.onload = function () { qr.hidden = false; };
      qr.onerror = function () { qr.hidden = true; };
      qr.src = d.qr;
    }

    var c = el('caduca');
    if (c && d.caduca) {
      var f = new Date(d.caduca);
      c.textContent = d.vigente === false
        ? 'Este cupón ya caducó.'
        : 'Caduca a las ' + f.getHours() + ':' + String(f.getMinutes()).padStart(2, '0') +
          ' del ' + f.getDate() + '/' + (f.getMonth() + 1) + '.';
    }
    forma.hidden = true;
    invitacion.hidden = true;
    listo.hidden = false;
  }

  if (forma) {
    forma.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var boton = el('boton');
      var original = boton ? boton.textContent : '';
      var correo = forma.querySelector('[name="correo"]').value.trim();
      var consiente = forma.querySelector('[name="consiente"]').checked;
      if (!correo) return;

      el('error').hidden = true;
      if (boton) boton.textContent = 'Un momento…';
      forma.querySelector('button').disabled = true;

      fetch(API, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ correo: correo, consiente: consiente, redes: leer() }),
      })
        .then(function (r) { return r.json().catch(function () { return null; }); })
        .then(function (d) {
          if (d && d.ok) { mostrarCupon(d); return; }
          var m = 'No pudimos generar tu cupón. Inténtalo otra vez.';
          if (d && d.error === 'correo') m = 'Revisa el correo, parece que tiene una errata.';
          if (d && d.error === 'redes') m = 'Nos faltan redes por seguir.';
          fallo(m);
        })
        .catch(function () {
          fallo('No hay conexión. Inténtalo otra vez en un momento.');
        })
        .then(function () {
          if (boton) boton.textContent = original;
          forma.querySelector('button').disabled = false;
        });
    });
  }

  caja.hidden = false;
  pintar();
})();
